/**
 * Utility functions for generating URLs
 */

/**
 * Generate a URL slug from a string
 * @param {string} text - The text to convert to a slug
 * @returns {string} - The generated slug
 */
export const createSlug = (text) => {
  if (!text) return '';
  
  return text.toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};

/**
 * Generate a solicitor profile URL
 * @param {Object} lawyer - The lawyer object containing name, location, etc.
 * @param {Object} searchParams - Current search parameters (optional)
 * @returns {string} - The generated URL path
 */
export const generateSolicitorUrl = (lawyer, searchParams = null) => {
  if (!lawyer || !lawyer.name) return '/';
  
  // Get search parameters if not provided
  const currentSearchParams = searchParams || new URLSearchParams(window.location.search);
  const areaParam = currentSearchParams.get("area");
  
  // Generate slug from name
  const nameSlug = createSlug(lawyer.name);
  
  // Generate location slug if available
  const locationSlug = lawyer.location ? createSlug(lawyer.location) : '';
  
  // Determine which URL format to use based on available parameters
  let pathname;
  
  if (areaParam && lawyer.location) {
    // If we have both practice area and city, use the full format
    const areaSlug = createSlug(areaParam);
    pathname = `/${areaSlug}/solicitor/${locationSlug}/${nameSlug}`;
  } else if (locationSlug) {
    // If we only have location/city
    pathname = `/solicitor/${locationSlug}/${nameSlug}`;
  } else {
    // Just the solicitor name
    pathname = `/solicitor/${nameSlug}`;
  }
  
  return pathname;
};

export const addUtmParams = (url) => {
    if (!url) return '';
    
    // Add https:// if no protocol is specified
    let formattedUrl = url;
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
        formattedUrl = `https://${url}`;
    }
    
    const separator = formattedUrl.includes('?') ? '&' : '?';
    return `${formattedUrl}${separator}utm_source=zahoot`;
}; 